import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "./Footer.tsx";
import styles from "./Layout.module.css";
import SocialLinks from "../SocialLinks.tsx";
import { setPreferredContentType } from "../../utils/preferences.ts";
import GroupLogin from "../GroupLogin.tsx";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const showBackButton = location.pathname !== "/";

  // ✅ Regex aggiornato: matcha sia con che senza groupId opzionale
  const pathMatch = location.pathname.match(
    /^\/region\/([^/]+)\/(trekkings|experiences)(?:\/[^/]+)?$/,
  );
  const name = pathMatch ? pathMatch[1] : null;
  const contentType = pathMatch
    ? (pathMatch[2] as "trekkings" | "experiences")
    : null;

  const { t, i18n } = useTranslation();
  const currentLng = i18n.language || "it";
  const handleChangeLng = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lng", lng);
  };

  const handleContentTypeChange = (type: "trekkings" | "experiences") => {
    if (name) {
      navigate(`/region/${name}/${type}`);
    }
  };

  // useEffect rimossa, return unico qui sotto
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>{t("ai_hiking", "AI Hiking")}</h1>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 8,
          }}
        >
          <button
            type="button"
            onClick={() => handleChangeLng("it")}
            style={{
              background: "none",
              border: "none",
              fontSize: 22,
              cursor: "pointer",
              opacity: currentLng === "it" ? 1 : 0.5,
              color: "white",
              textShadow: "0 1px 4px #000",
            }}
            aria-label="Italiano"
          >
            IT
          </button>
          <button
            type="button"
            onClick={() => handleChangeLng("en")}
            style={{
              background: "none",
              border: "none",
              fontSize: 22,
              cursor: "pointer",
              opacity: currentLng === "en" ? 1 : 0.5,
              color: "white",
              textShadow: "0 1px 4px #000",
            }}
            aria-label="English"
          >
            EN
          </button>
        </div>
        {/* GroupLogin rimosso: ora solo nel menu laterale desktop */}
        {showBackButton && (
          <React.Fragment>
            <button
              type="button"
              onClick={() => navigate("/")}
              className={styles.backButton}
            >
              ←{" "}
              {t("back_to_regions", "Torna alla mappa delle regioni d'Italia")}
            </button>
            {name && contentType && (
              <div className={styles.togglesContainer}>
                <div className={styles.toggleContainer}>
                  <button
                    type="button"
                    className={`${styles.toggleButton} ${contentType === "trekkings" ? styles.active : ""}`}
                    onClick={() => handleContentTypeChange("trekkings")}
                  >
                    {t("trails", "Percorsi")}
                  </button>
                  <button
                    type="button"
                    className={`${styles.toggleButton} ${contentType === "experiences" ? styles.active : ""}`}
                    onClick={() => handleContentTypeChange("experiences")}
                  >
                    {t("activities", "Attività")}
                  </button>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
      </header>
      <main className={styles.content}>{children}</main>
      <SocialLinks />
      <Footer />
    </div>
  );
};

export default Layout;
